import { eachDayOfInterval, isAfter, isBefore, isSameDay } from '@repo/date-time';
export function useDateRangePicker(value, onChange, flaggedDates) {
    const isRangePossible = (start, end) => {
        return !eachDayOfInterval({ start, end }).some((day) => flaggedDates.some((dayFlag) => dayFlag.flag === 'alert' && isSameDay(dayFlag.date, day)));
    };
    const handleDateChosen = (newDate) => {
        const [start, end] = value;
        const onlyStartDefined = start && end === undefined;
        const newDateIsAfterStart = start && !isBefore(newDate, start);
        const rangeIsDefined = start && end;
        const newDateIsAfterStartButIsNotEnd = rangeIsDefined && isAfter(newDate, start) && !isSameDay(newDate, end);
        const shouldCloseRange = (onlyStartDefined && newDateIsAfterStart) || (rangeIsDefined && newDateIsAfterStartButIsNotEnd);
        if (shouldCloseRange && isRangePossible(start, newDate)) {
            onChange([start, newDate]);
        }
        else {
            onChange([newDate, undefined]);
        }
    };
    return { handleDateChosen };
}
